import { trackPaymentErrors } from '@/helpers/facebookPixelEvents'

const apiUrl = process.env.REACT_APP_SOLID_GATE_API_URL
const headers = {
  'Content-Type': 'application/json',
}

export const createSolidGatePaymentIntent = async (data: {
  email: string
  productId: string
  failUrl: string
  trafficSource?: string
}) => {
  try {
    const response = await fetch(`${apiUrl}/payment-intent`, {
      method: 'POST',
      headers,
      body: JSON.stringify({
        productId: data.productId,
        email: data.email,
        failUrl: data.failUrl,
        trafficSource: data.trafficSource ?? '',
      }),
    })
    return await response.json()
  } catch (e) {
    trackPaymentErrors('createCustomer', e)
    return e
  }
}
